'use strict';

import React, { Component } from 'react';
import styled from 'styled-components';
import Moment from 'moment';
import axios from 'axios'; //http Client

export default class LatestPostsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts : [],
      nrOfPosts: props.nrOfPosts ? props.nrOfPosts: 2,
      envisionAPI: axios.create({
        baseURL: 'https://envision.ghost.io/ghost/api/v2',
        timeout: 5000
      }),
    };
  }

  async componentDidMount(){ //https://envision.ghost.io/ghost/api/v2/content/posts/?key=b3934751b71adec42296155a18&filter=tag:pistlar
    let posts = this.state.nrOfPosts;
    return await this.state.envisionAPI.get('/content/posts/?key=b3934751b71adec42296155a18&filter=tag:pistlar&limit='+posts)
      .then( (response) => {
        this.setState({
          posts : response.data.posts,
        });
      })
      .catch( error => {
      console.log(error);
    });
  }

  render() {

    if(this.state.posts.length == 0){
      return (null);
    }
    else{
      return (
        <Container>
          <SectionTitle>Nýjustu pistlarnir</SectionTitle>
          <SolutionSection>
            {this._renderPosts()}
          </SolutionSection>
        </Container>
      );
      }
    }

    _renderPosts(){
      let result = [];
      let i = 0;



      for(let eachItem of this.state.posts){
        result.push(
          <PostsCard
            key={eachItem.id}
            category= {eachItem.published_at}
            title={eachItem.title}
            excerpt={eachItem.excerpt}
            link={eachItem.slug}
          />
        );
        if(++i == this.state.nrOfPosts ){
          break;
        }
      };

      result.push(
        <ImageCard key="pistlar">
          <ImageCardTitle>FLEIRI PISTLAR</ImageCardTitle>
          <a href="tag/pistlar/">
            <img src={"./assets/img/pistlar-image.jpg"}
                style={imageCardStyle}/>
          </a>
        </ImageCard>
      );

      return (result);
    }
  }

 class PostsCard extends Component {
  constructor(props) {
    super(props);
  }

  getDateTime = (dateTime) => {
    let date =  new Moment(dateTime).locale('is');

    return  date.format('ll'); // ("D mmm YYYY");
  }

  render() {
    const {category, title, excerpt,link} = this.props;
    return (
      <Card>
        <CardContent>
          <a style={cardLinkStyle} href={link}>
            <div id={title}>
             {<CardCategory>{this.getDateTime(category)}</CardCategory>  }
              <CardTitle>{title}</CardTitle>
            </div>
            <CardExcerpt>
              {
                this.addLineFeed(excerpt)
                //excerpt
              }
            </CardExcerpt>
          </a>
        </CardContent>
    </Card>
    );
  }

  addLineFeed(text){
    return text.split('\n').map((item, i) => {
        return <p key={i}>{item}</p>;
    });
  }
}

/*
*  LatestPostsContainer styles
*/
const Container = styled.section`
  display: flex;
  position: relative;
  flex-direction: row;
  flex-wrap: wrap;
  background: #fff;
//width: fit-content;
  width: fit-content;
`;

const SectionTitle = styled.section`
  display: flex 1;
  //height: 60px;
  margin-top: 20px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  margin-left: 1.8rem;
  color: #5E7CA0;
  font-size:  1.3em;
  line-height: 1.2em;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

const SolutionSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const imageCardStyle =  {
  width: 'fit-content',
  height: '300px',
  objectFit: 'cover',
  minWidth: '300px',
};

const ImageCard = styled.section`
  flex: 2.5 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 0 1.8rem 3.6rem;
  max-height: inherit;
  max-width:  inherit;
  min-width: 300px;

  background: #fff center center;
  background-size: cover;

  transition: all 0.5s ease;
  &:hover {
    box-shadow: rgba(39,44,49,0.07) 8px 28px 50px, rgba(39, 44, 49, 0.04) 1px 6px 12px;
    transition: all 0.4s ease;
    transform: translate3D(0, -1px, 0) scale(1.02);
  }
`;

const Card = styled.section`
  flex: 1 1 315px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 0 1.8rem 3.6rem;
  max-height: 300px;

  background: #fff center center;
  background-size: cover;

  transition: all 0.5s ease;
  &:hover {
    box-shadow: rgba(39,44,49,0.07) 8px 28px 50px, rgba(39, 44, 49, 0.04) 1px 6px 12px;
    transition: all 0.4s ease;
    transform: translate3D(0, -1px, 0) scale(1.02);
  }
`;

const CardContent = styled.section`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

//Inline styling https://codeburst.io/4-four-ways-to-style-react-components-ac6f323da822
const cardLinkStyle =  {
  position: 'relative',
  //'flex-grow': '1',
  display: 'block',
  padding: '25px 25px 25px',
  color: '#343a40',
};

const CardCategory = styled.section`
  display: block;
  margin-bottom: 4px;
  color: #B9B2AE;
  font-size: 1.05em;
  line-height: 1.05em;
  font-weight: 500;
  letter-spacing: 0.5px;
  //text-transform: uppercase;
`;

const CardTitle = styled.section`
  padding-bottom:15px;
  color: #5E7CA0;
  margin-top: 0;
  font-size: 1.25em;
  line-height: 1.0em;
  font-weight:600;
`;

const ImageCardTitle = styled.section`
  color: #FFF;
  margin-top: 0;
  font-size: 1.25em;
  line-height: 1.0em;
  font-weight: 600;
  position: absolute;
  margin: 1rem;
  text-transform: uppercase;
`;


const CardExcerpt = styled.section`
  color: #5E7CA0;
  font-size: 1.25em;
  line-height: 1.125em;
`;
